import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link,useNavigate } from "react-router-dom";
import DefaultBanner from "./pic/default-banner.png";

export default function Adhero() {
  const api = "https://mkbackend-production.up.railway.app";

  const [ads, setAds] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const intervalRef = useRef(null);

  const slides = [{ isDefault: true }, ...ads];
  const slidesRef = useRef(slides);
  slidesRef.current = slides;
    
    const navigate = useNavigate()
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [userName, setUserName] = useState('')
      const [shopPic, setShopPic] = useState('')
      const [isShopCreated, setIsShopCreated] = useState(false)
  
      useEffect(() => {
          // Check if user is logged in
          const token = localStorage.getItem('token')
          if (token) {
              setIsLoggedIn(true)
              // Get user data from localStorage
              const userData = localStorage.getItem('shop')
              if (userData) {
                  try {
                      const user = JSON.parse(userData)
                      setUserName(user.shopName || 'User')
                      setShopPic(user.image || '')
                      // Check if shop is created (has shop name)
                      if (user.shopName && user.shopName.trim() !== '') {
                          setIsShopCreated(true)
                      }
                  } catch (error) {
                      console.error('Error parsing user data:', error)
                  }
              }
          } else {
              setIsLoggedIn(false)
              setIsShopCreated(false)
          }
      }, [])
  
       const handleShopClick = () => {
        if (isShopCreated) {
            // Navigate to shop page if shop exists
            navigate('/allproducts')
        } else {
            // Navigate to create shop page if no shop
            navigate('/create-shop')
        }
    }


  useEffect(() => {
    fetchAds();
  }, []);

  const fetchAds = async () => {
    try {
      const res = await axios.get(`${api}/ads`);
      if (res.data.success) {
        setAds(res.data.ads);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    ads.forEach((item) => {
      if (item?.adhero) {
        const img = new Image();
        img.src = item.adhero;
      }
    });
  }, [ads]);

  const goNext = () => {
    const len = slidesRef.current.length;
    setCurrentSlide((prev) => (prev + 1) % len);
  };

  const goPrev = () => {
    const len = slidesRef.current.length;
    setCurrentSlide((prev) => (prev - 1 + len) % len);
  };

  const startInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(goNext, 3000);
  };

  useEffect(() => {
    startInterval();
    return () => clearInterval(intervalRef.current);
  }, []);

  const handleNext = () => {
    goNext();
    startInterval();
  };

  const handlePrev = () => {
    goPrev();
    startInterval();
  };

  const current = slides[currentSlide] || slides[0];
  const isDefaultSlide = current?.isDefault;
  const displaySrc = isDefaultSlide ? DefaultBanner : current?.adhero || DefaultBanner;

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          position: "relative",
          width: "100%",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        }}
      >
        {/* Main image - aspect ratio responsive */}
        <div
          style={{
            width: "100%",
            aspectRatio: "16 / 7",
            position: "relative",
          }}
        >
          <img
            src={displaySrc}
            onError={(e) => {
              e.target.src = DefaultBanner;
            }}
            alt="Advertisement"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />

          {/* Bottom gradient overlay for text/button legibility */}
          <div
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,
              height: "45%",
              background:
                "linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.25) 55%, rgba(0,0,0,0) 100%)",
              pointerEvents: "none",
            }}
          />

          {/* Prev / Next arrows */}
          {slides.length > 1 && (
            <>
              <button
                onClick={handlePrev}
                aria-label="Previous"
                style={{
                  position: "absolute",
                  left: "clamp(8px, 2vw, 16px)",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.18)",
                  backdropFilter: "blur(6px)",
                  WebkitBackdropFilter: "blur(6px)",
                  border: "1px solid rgba(255,255,255,0.35)",
                  color: "#fff",
                  borderRadius: "50%",
                  width: "clamp(28px, 4vw, 38px)",
                  height: "clamp(28px, 4vw, 38px)",
                  cursor: "pointer",
                  fontSize: "clamp(16px, 2vw, 20px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1,
                  transition: "background 0.2s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.32)")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.18)")}
              >
                ‹
              </button>

              <button
                onClick={handleNext}
                aria-label="Next"
                style={{
                  position: "absolute",
                  right: "clamp(8px, 2vw, 16px)",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.18)",
                  backdropFilter: "blur(6px)",
                  WebkitBackdropFilter: "blur(6px)",
                  border: "1px solid rgba(255,255,255,0.35)",
                  color: "#fff",
                  borderRadius: "50%",
                  width: "clamp(28px, 4vw, 38px)",
                  height: "clamp(28px, 4vw, 38px)",
                  cursor: "pointer",
                  fontSize: "clamp(16px, 2vw, 20px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1,
                  transition: "background 0.2s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.32)")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.18)")}
              >
                ›
              </button>
            </>
          )}

          {/* Action buttons overlaid at bottom of image */}
          <div
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              bottom: "clamp(10px, 2.5vw, 18px)",
              display: "flex",
              justifyContent: "center",
              gap: "clamp(10px, 2vw, 18px)",
              flexWrap: "wrap",
              padding: "0 12px",
            }}
          >
            {!isDefaultSlide && current ? (
              <>
                <a 
                  href={current.shopUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={pillButtonStyle}
                >
                  🏪 Shop Visit
                </a>

                <a 
                  href={current.productUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={pillButtonStyle}
                >
                  🛍️ Product Visit
                </a>
              </>
            ) : (
              <>
              {isLoggedIn ?(
                       <button onClick={handleShopClick} className="shop-btn">
                            {isShopCreated ? 'My Shop' : 'Create Shop'}
                        </button>):(
                          <button className="login-btn">  <Link to="/login">Login</Link></button>
                        )}
                <Link to="/createad" style={pillButtonStyle}>
                  📢 Create Ad
                </Link>
              </>
            )}
          </div>

          {/* Dot indicators */}
          {slides.length > 1 && (
            <div
              style={{
                position: "absolute",
                top: "clamp(8px, 2vw, 14px)",
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                gap: "6px",
              }}
            >
              {slides.map((_, idx) => (
                <div
                  key={idx}
                  style={{
                    width: idx === currentSlide ? "18px" : "6px",
                    height: "6px",
                    borderRadius: "3px",
                    background:
                      idx === currentSlide
                        ? "#fff"
                        : "rgba(255,255,255,0.5)",
                    transition: "width 0.3s ease, background 0.3s ease",
                  }}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const pillButtonStyle = {
  background: "rgba(255,255,255,0.95)",
  color: "#1a1a1a",
  padding: "clamp(6px, 1.2vw, 10px) clamp(14px, 2.5vw, 22px)",
  borderRadius: "999px",
  fontSize: "clamp(12px, 1.6vw, 14px)",
  fontWeight: 600,
  textDecoration: "none",
  whiteSpace: "nowrap",
  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  transition: "transform 0.15s ease, background 0.15s ease",
};